import React, { FC, ReactNode } from 'react'
import styles from 'styles/components/modal.module.scss'
import { Card, CardInner } from 'components/Card'

type Props = {
  open: boolean
  closeModal: () => void
  children: ReactNode
}

const BasicModal: FC<Props> = (props) => {
  const { open, closeModal, children } = props

  return (
    // styles.openクラスを適用するとopacityのアニメーションでフェードイン
    <div className={open ? styles.open : ''}>
      <div className={styles.overlay}>
        <div className={styles.overlay__background} onClick={closeModal} />
        {open && (
          <div className={styles.overlay__container}>
            <Card>
              <CardInner>{children}</CardInner>
            </Card>
          </div>
        )}
      </div>
    </div>
  )
}

export default BasicModal
